import styled, { keyframes } from "styled-components";

const float = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(20px); }
`;

export const Wrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(to bottom, #f8faff, #eef2fb);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding: 2rem;

  &::before,
  &::after {
    content: "";
    position: absolute;
    border-radius: 50%;
    filter: blur(30px);
    opacity: 0.8;
    animation: ${float} 20s infinite ease-in-out;
    z-index: 0;
  }

  &::before {
    background: radial-gradient(circle, rgba(169, 159, 255, 0.6) 0%, transparent 90%);
    width: 250px;
    height: 250px;
    top: 20%;
    left: 10%;
  }

  &::after {
    background: radial-gradient(circle, rgba(206, 171, 255, 0.6) 0%, transparent 90%);
    width: 300px;
    height: 300px;
    top: -10%;
    right: -5%;
  }
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  z-index: 1;
`;

export const Title = styled.h1`
  font-size: 3rem;
  font-weight: bold;
  background: linear-gradient(90deg, #8a54d0, #5f79f4);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const Logo = styled.img`
  height: 50px;
  margin-bottom: 0.5rem;
  @media (max-width: 480px) {
    height: 32px;
  }
`;


export const SubTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin-top: 0.5rem;
  background: linear-gradient(90deg, #8a54d0, #5f79f4);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const Text = styled.p`
  margin-top: 0.6rem;
  font-size: 1rem;
  color: #5b5b5b;
`;

export const Card = styled.div`
  background: #fff;
  padding: 2.5rem 2rem;
  border-radius: 1rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  width: 100%;
  max-width: 400px;
  z-index: 1;
`;

export const BackLink = styled.button`
  background: none;
  border: none;
  color: #9333ea;
  font-weight: 500;
  margin-bottom: 1.2rem;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  transition: all 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    color: #7c3aed;
    text-decoration: underline;
  }

  &:focus {
    outline: none;
    text-decoration: underline;
  }
`;
